import { render } from "./taskComp.vue?vue&type=template&id=3f9592a7"
import script from "./taskComp.vue?vue&type=script&lang=js"
export * from "./taskComp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__